import React, { useState, useEffect } from 'react';
import DataTable from '../DataTable/DataTable.js';
import Typography from '@material-ui/core/Typography';
import { getDatafromDataModelIdPayload } from '../../utils/payload';
import useStyles from './style';

const SimpleTableViewer = (props) => {
  const { block, config, formData, selectedStep, blockState, appId, orgId, updateTableData } = props;
  const { chartUniqueId } = props.data;
  const { dataElement } = block;

  const classes = useStyles();

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  const [blockHeaders, setBlockHeaders] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentDataModel, setCurrentDataModel] = useState({});

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const fetchDataModel = () => {
    let payload = { appid: appId, orgId };
    if (block?.dataModel || selectedStep?.dataModel) {
      let ID = block.dataModel || selectedStep.dataModel;
      if (!formData?.dataModel?.[ID]) {
        if (!formData?.dataModel?.[ID] && !formData[`${ID}_loading`]) {
          payload['dataModelId'] = ID;
          payload['dataUniqueId'] = ID;
          props.getDataModelById(payload);
        }
      } else {
        block?.dataModel
          ? setCurrentDataModel(formData?.dataModel?.[ID])
          : setCurrentDataModel(formData?.dataModel?.[ID]);
      }
    }
  };

  const getDatafromDataModelId = (searchKey) => {
    let conditions = [{
      selectedConditionDataElement: dataElement,
      selectedConditionOperator: "in",
      value: blockState[dataElement] ? blockState[dataElement] : ["NET 60"],
      selectedConditionClause: "and"
    }];

    let modelDatapayload = getDatafromDataModelIdPayload(
      appId,
      block.dataModel || selectedStep.dataModel,
      0,
      5,
      conditions
    );
    if (searchKey) modelDatapayload['search'] = searchKey;

    props.getModelData({
      ...modelDatapayload,
      dataUniqueId: chartUniqueId + '_assosiatedTabledata'
    });
  };

  useEffect(() => {
    if (formData?.document[chartUniqueId + '_assosiatedTabledata']?.data?.length) {
      let dataList = formData?.document[chartUniqueId + '_assosiatedTabledata']?.data || [];
      let total = formData?.document[chartUniqueId + '_assosiatedTabledata']?.total || 0;

      setTableData(dataList);
      setTotalRecords(total);

      if (updateTableData) updateTableData(block.type, dataList);
    } else {
      setTableData([]);
      setTotalRecords(0);
      if (updateTableData) updateTableData(block.type, []);
    }
  }, [props.formData?.document[chartUniqueId + '_assosiatedTabledata']]);

  useEffect(() => {
    fetchDataModel();
    getDatafromDataModelId();
  }, [block]);

  useEffect(() => {
    if (formData?.dataModel[block.dataModel || selectedStep.dataModel]) {
      let dataElements = formData.dataModel[block.dataModel || selectedStep.dataModel].dataElements || [];
      if (dataElements?.length) {
        let fdes = [];
        if (block?.config[0]?.dataElements) {
          fdes = JSON.parse(JSON.stringify(block?.config[0]?.dataElements));
          fdes = fdes.map(fde => {
            let sde = dataElements.find(de => de.name === fde.value);
            if (sde?.name) return { ...sde, ...fde };
            return fde;
          });
          setBlockHeaders(fdes);
          getDatafromDataModelId();
        }
      }
    }
  }, [formData?.dataModel]);

  // currently always true per your code
  const hasData = true;

  return (
    <div className={classes.root}>
      <Typography className={classes.title}>{block.title}</Typography>

      {!hasData ? (
        <div className={classes.emptyWrap}>
          <Typography className={classes.emptyText}>Nothing to show</Typography>
        </div>
      ) : (
        (props.formData?.[chartUniqueId + '_assosiatedTabledata_loading'] ||
          props.formData?.[block.dataModel + '_loading'])
          ? props.loader
          : (
            <DataTable
              headers={blockHeaders}
              data={tableData}
              page={page}
              rowsPerPage={rowsPerPage}
              totalRecords={totalRecords}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              actionColumn={false}
              actionIcon="/media/createStepper/deleteContracts.svg"
              uniqueId={1011}
              onActionClick={(row) => {
                const documentId = row._id;
                if (documentId) {
                  // handleDeleteDocument(documentId); // (not present in this component)
                }
              }}
              showPagination={false}
            />
          )
      )}
    </div>
  );
};

export default SimpleTableViewer;
